import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      const hash = location.hash || "";
      const match = /session_id=([^&]+)/.exec(hash);
      if (!match) { navigate("/", { replace: true }); return; }
      const session_id = decodeURIComponent(match[1]);
      try {
        const user = await exchangeSession(session_id);
        await refresh();
        // Clean hash and redirect home
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center helptext">
      Signing you in…
    </div>
  );
}
